import React from 'react';
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
  DragEndEvent,
} from '@dnd-kit/core';
import {
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { useFunnelStore } from '../../store/funnelStore';
import SectionItem from './SectionItem';

/**
 * Section Tree Component
 * Displays a sortable list of sections in the funnel
 */
const SectionTree: React.FC = () => {
  const { funnel, reorderSections } = useFunnelStore();
  const sections = funnel.sections;

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  const handleDragEnd = (event: DragEndEvent) => {
    const { active, over } = event;

    if (over && active.id !== over.id) {
      const oldIndex = sections.findIndex((s) => s.id === active.id);
      const newIndex = sections.findIndex((s) => s.id === over.id);
      
      if (oldIndex !== -1 && newIndex !== -1) {
        reorderSections(oldIndex, newIndex);
      }
    }
  };

  if (sections.length === 0) {
    return (
      <div className="p-4 text-center text-gray-500 text-sm">
        No sections yet. Click "Add Section" to get started.
      </div>
    );
  }

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={handleDragEnd}
    >
      <SortableContext
        items={sections.map((s) => s.id)}
        strategy={verticalListSortingStrategy}
      >
        <div className="py-2">
          {sections.map((section, index) => (
            <SectionItem key={section.id} section={section} index={index} />
          ))}
        </div>
      </SortableContext>
    </DndContext>
  );
};

export default SectionTree;

